module.exports = __webpack_public_path__ + "img/eb.685b5928.png";